import React from 'react';

import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';

import Copyright from 'components/Copyright';

const useStyles = makeStyles(theme => (
  {
    container: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(4),
      width: "100%"
    }
  }));

export default function Footer(props)
{
  const classes = useStyles();
  return (
    <footer className={classes.container}>
      <Copyright />
    </footer>
  );
}